module.exports = __webpack_public_path__ + "img/005-gamepad.85101485.svg";